import { render } from "./FooterPage.vue?vue&type=template&id=588e1dcf&scoped=true"
const script = {}

import "./FooterPage.vue?vue&type=style&index=0&id=588e1dcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588e1dcf"]])

export default __exports__